const clientId = process.env.REACT_APP_AAD_APP_CLIENT_ID //'3b562c96-475e-4cdd-ac20-e61078a8d512' 
const tenantId = process.env.REACT_APP_AAD_APP_TENANT_ID //'afe0add4-a14c-47c4-bc62-fc6ea2cb1e65' 
const redirectUri = process.env.REACT_APP_AAD_APP_REDIRECT_URI //'http://localhost:3000/dashboard' 
export const msalConfigPhmc = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
        scopes: ["user.read"],
    },
    cache: {
        cacheLocation: "sessionStorage",
        // storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
}


const partnerClientId = process.env.REACT_APP_ASSOCIATE_AAD_CLIENT_ID //'s3b562c96-475e-4cdd-ac20-e61078a8d512'
const partnerTenantId = process.env.REACT_APP_ASSOCIATE_AAD_TENANT_ID //  'afe0add4-a14c-47c4-bc62-fc6ea2cb1e65' 
const partnerRedirectUri = process.env.REACT_APP_ASSOCIATE_AAD_REDIRECT_URI //'http://localhost:3000/dashboard' 

export const msalConfigAssociate = {
    auth: {
        clientId: `${partnerClientId}`,
        authority: `https://login.microsoftonline.com/${partnerTenantId}`,
        redirectUri: 'https://phmchosting.z13.web.core.windows.net/',
        scopes: ["user.read"],
    },
    cache: {
        cacheLocation: "sessionStorage",
        // storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
}
export const loginRequest = {
    scopes: ['user.read'],
};
